var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71063 1.61523L7.7112 1.61476C8.59675 0.903541 10.0404 0.905356 10.9444 1.62527C10.9446 1.62542 10.9448 1.62557 10.945 1.62572L16.9451 6.42578C17.2427 6.66935 17.5155 7.06476 17.6945 7.53334C17.8733 8.00135 17.9343 8.47859 17.8768 8.85918L16.7235 15.7609C16.7233 15.7616 16.7232 15.7623 16.7231 15.763C16.5178 16.9382 15.3598 17.9167 14.1807 17.9167H4.46406C3.26484 17.9167 2.13619 16.9639 1.93102 15.773C1.93093 15.7725 1.93084 15.772 1.93076 15.7715L0.776305 8.86306L0.776015 8.86135C0.711129 8.47852 0.767765 8.00109 0.945878 7.53402C1.12396 7.06702 1.39984 6.67237 1.70516 6.42877L1.70646 6.42773L7.71063 1.61523ZM9.32239 16.4375C10.1124 16.4375 10.7599 15.7901 10.7599 15V12.25C10.7599 11.46 10.1124 10.8125 9.32239 10.8125C8.53235 10.8125 7.88489 11.46 7.88489 12.25V15C7.88489 15.7901 8.53235 16.4375 9.32239 16.4375Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/homeWhite.a49bce2f44eea0c566a5a571d731a089.svg";
export { ForwardRef as ReactComponent };